export default __webpack_public_path__ + "static/media/shape2.60fd4a48.png";